import { render, staticRenderFns } from "./sustainability-reports.vue?vue&type=template&id=3cb0cae6&"
import script from "./sustainability-reports.vue?vue&type=script&lang=js&"
export * from "./sustainability-reports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports